import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';
import { getSkuById } from './api-service';
import { Viewer } from './gaussian-splats-3d.module'

const View3DNew = () => {
    const query = new URLSearchParams(useLocation().search);
    const sku_id = query.get('sku_id');
    const autoRotate = query.get('autoRotate');
    const viewerRef = useRef(null);

    if (!sku_id) {
        const errorMessage = 'Error: sku_id is required in URL parameters';
        console.error(errorMessage);
        document.body.innerHTML = `<div style="color: white; text-align: center; margin-top: 50px;">${errorMessage}</div>`;
        throw new Error(errorMessage);
    }

    useEffect(() => {
        const initViewer = async () => {
            try {
                const skuData = await getSkuById(sku_id);
                
                // Form the URL with the sku_id (Not taking this from env coz of 360 bucket conflict)
                const pointCloudUrl = `https://doxwiy8g83880.cloudfront.net/processed/${sku_id}/point_cloud.ply`;

                const initialCameraPosition = skuData?.config_details?.model_config?.new_perams?.initialCameraPosition;
                const initialCameraDistance = skuData?.config_details?.model_config?.torus_config?.torus_inner_radius;

                const angleDeviation = Math.atan(0.01); // Need this value to be dynamic later

                const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                
                // Create viewer instance with custom controls
                const viewer = new Viewer({
                    'selfDrivenMode': true,
                    'cameraUp':[0,0,1],
                    'initialCameraPosition': initialCameraPosition || [-0.5000521540641786, -3.7422714233398438, -0.06316226720809937],
                    'initialCameraLookAt': [0, 0, 0],
                    'sharedMemoryForWorkers': false,
                    'sphericalHarmonicsDegree': 0,
                    "integerBasedSort":true,
                    "ignoreDevicePixelRatio": false,
                    "devicePixelRatio": isMobile ? 0.8 : 1
                });

                // Store viewer instance in ref
                viewerRef.current = viewer;

                // Load the scene
                await viewer.addSplatScene(pointCloudUrl, {
                    'splatAlphaRemovalThreshold': 0,
                    'progressiveLoad': true,
                    'showLoadingUI': true,
                    'position': [0, 0, 0],
                    'rotation': [0, 0, 0, 0],
                    'scale': [1, 1, 1]
                });

                viewer.start();
                viewer.controls.minDistance = initialCameraDistance * 0.9;
                viewer.controls.maxDistance = initialCameraDistance * 1.1;
                viewer.controls.minPolarAngle = Math.PI / 2 - angleDeviation; // radians
                viewer.controls.maxPolarAngle =  Math.PI /2 + angleDeviation; // radians
                viewer.controls.dampingFactor = 0.06;
                viewer.controls.autoRotateSpeed = 2.0;
                // Set autoRotate to true by default, only disable if explicitly set to 'false'
                viewer.controls.autoRotate = autoRotate !== 'false';
                viewer.controls.enableDamping = true; // Enable damping (inertia)
                viewer.controls.zoomSpeed = 0.5; // Reduce zoom speed for smoother zooming
                viewer.update();
            } catch (error) {
                const errorMessage = `Error fetching SKU data: ${error.message}`;
                console.error(errorMessage);
                document.body.innerHTML = `<div style="color: white; text-align: center; margin-top: 50px;">${errorMessage}</div>`;
            }
        };

        initViewer();

        // Cleanup function
        return () => {
            if (viewerRef.current) {
                viewerRef.current.dispose();
                viewerRef.current = null;
            }
        };
    }, [sku_id]);
 
    return (
        <>
        </>
    );
}

export default View3DNew